import { createHead } from '@unhead/vue/client';
import { createApp } from 'vue';

import App from '@/App.vue';
import { getConfig } from '@/core/lib/Config';
import { createRouter } from '@/core/router';
import { registerDomains } from '@/Domains';
import { registerPlugins } from '@/Plugins';

void (async () => {
  const config = await getConfig();
  const router = createRouter();
  const head = createHead();

  const app = createApp(App);

  app.config.performance = true;

  registerPlugins({ app, router, config });
  registerDomains({ app, router, config });

  app.use(router).use(head).mount('#app');
})();
